import React from "react";

interface StatusBadgeProps {
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  role: "admin" | "doctor" | "secretary";
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, role }) => {
  const getStatusDisplay = (status: string) => {
    switch (status) {
      case "PENDING":
        return { text: "En attente", color: "bg-yellow-100 text-yellow-800" };
      case "APPROVED":
        return { text: "Approuvé", color: "bg-green-100 text-green-800" };
      case "REJECTED":
        return { text: "Rejeté", color: "bg-red-100 text-red-800" };
      case "CANCELLED":
        return { text: "Annulé", color: "bg-gray-100 text-gray-800" };
      default:
        return { text: status, color: "bg-blue-100 text-blue-800" };
    }
  };

  const { text, color } = getStatusDisplay(status);
  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${color} ${
        role === "admin" ? "text-sm" : ""
      }`}
    >
      {text}
    </span>
  );
};

export default StatusBadge;